import styled from 'styled-components';

export const StyledStickyMenu = styled.ul`
  display: flex;
  flex-direction: row;
  background: white;
  align-self: center;
  position: fixed;
  max-width: 90%;
  top: 105px;
  padding: 0;
  z-index: 1;

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
    width: auto;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
    top: 130px;
    left: 26px;
    background: transparent;
    z-index: 0;
    align-self: unset;
    flex-direction: column;
  }
`;

export const StyledInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 44px 1rem;
  box-sizing: border-box;

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
    padding: 44px 42px;
    width: 470px;
  }
`;
